import React, { ReactNode, useMemo, useState } from 'react';

import { EnhancedPersonSitterProfile } from '@rover/rsdk/src/apiClient/latest/model/enhancedPersonSitterProfile';

import {
  type SitterProfileVersion,
  type ViewMode,
  RevampProfileContext,
} from '../hooks/useRevampProfileContext';
import useSittersRatesToggle from '../hooks/useSittersRatesToggle';

interface RevampProfileProviderProps {
  children: ReactNode;
  serviceType: string | undefined;
  setServiceType: (serviceType: string) => void;
  sitterData: EnhancedPersonSitterProfile;
  viewMode: ViewMode;
  pageTreatment: SitterProfileVersion;
  contactUrl: string;
  isShowingPriceInCurrency?: boolean;
}

export const RevampProfileProvider = ({
  children,
  serviceType,
  setServiceType,
  sitterData,
  viewMode,
  pageTreatment,
  contactUrl,
  isShowingPriceInCurrency,
}: RevampProfileProviderProps): JSX.Element => {
  const [reviewsModalOpen, setReviewsModalOpen] = useState(false);
  const { showSittersRates, onToggleSittersRates } = useSittersRatesToggle(
    isShowingPriceInCurrency,
    sitterData.authenticatedContext?.shouldShowBhToggle
  );

  const contextValue = useMemo(
    () => ({
      serviceType,
      setServiceType,
      sitterData,
      viewMode,
      pageTreatment,
      reviewsModalOpen,
      setReviewsModalOpen,
      contactUrl,
      showSittersRates,
      onToggleSittersRates,
    }),
    [
      serviceType,
      setServiceType,
      sitterData,
      viewMode,
      pageTreatment,
      reviewsModalOpen,
      contactUrl,
      showSittersRates,
      onToggleSittersRates,
    ]
  );

  return (
    <RevampProfileContext.Provider value={contextValue}>{children}</RevampProfileContext.Provider>
  );
};
